/**
 * @generated SignedSource<<920a59965964a2d7e587b1d7db6284c7>>
 * @relayHash e00b9ac070e3c587e6c54338b2927c57
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 0c000f877912fd9c73d137c8b432d647b08693d0efb0cac14485988e83d18718

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { JiraBusinessTimelineAppWithExperimentQuery } from './JiraBusinessTimelineAppWithExperimentQuery.graphql';

const node: PreloadableConcreteRequest<JiraBusinessTimelineAppWithExperimentQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "0c000f877912fd9c73d137c8b432d647b08693d0efb0cac14485988e83d18718",
    "metadata": {},
    "name": "JiraBusinessTimelineAppWithExperimentQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
